// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__yIr0C","tab":"Tabs_tab__2kt3V","tabActive":"Tabs_tabActive__1mg5z"};